import { useSelector } from "react-redux";
import ImageModal from "../components/modals/ImageModal";
import LogoutVerificationModal from "../components/modals/LogoutVerificationModal";
import ResultModal from "../components/modals/ResultModal";
import UpdateEgeyurtIletisimItemModal from "../components/modals/UpdateEgeyurtIletisimItemModal";
import AddEgeyurtIletisimItemModal from "../components/modals/AddEgeyurtIletisimItemModal";
import DeleteEgeyurtIletisimBirimPermissionModal from "../components/modals/DeleteEgeyurtIletisimBirimPermissionModal";
import DeleteAnasafaDuyuruItemPermissionModal from "../components/modals/DeleteAnasafaDuyuruItemPermissionModal";
import UyeMeslekiYeterlilikModal from "../components/modals/UyeMeslekiYeterlilikModal";
import UyeIslemleriOptionsModal from "../components/modals/UyeIslemleriOptionsModal";
import UyeIsvereniModal from "../components/modals/UyeIsvereniModal";
import AracMuayeneSorguModal from "../components/modals/AracMuayeneSorguModal";
import AracYetkiBelgesiSorguModal from "../components/modals/AracYetkiBelgesiSorguModal";
import AracCezaSorguModal from "../components/modals/AracCezaSorguModal";
import ResultErrAracMuayeneModal from "../components/modals/ResultErrAracMuayeneModal";
import SigortaTeklifAlResultModal from "../components/modals/SigortaTeklifAlResultModal";
import FirmaKaraListeEkleModal from "../components/modals/FirmaKaraListeEkleModal";
import AdminKaraListeEkleModal from "../components/modals/adminKaraListe/AdminKaraListeEkleModal";
import SurucuProfilModal from "../components/modals/SurucuProfilModal";
import SearchModal from "../components/modals/SearchModal";
import GarajDetayModal from "../components/modals/GarajDetayModal";
import AddGarajYogunlukEntryModal from "../components/modals/AddGarajYogunlukEntryModal";
import AdminSettingsPermissionModal from "../components/modals/AdminSettingsPermissionModal";
import AddSSSItemModal from "../components/modals/SSS/AddSSSItemModal";
import UpdateSSSItemModal from "../components/modals/SSS/UpdateSSSItemModal";
import DeleteSSSItemModal from "../components/modals/SSS/DeleteSSSItemModal";
import DeleteKKKItemModal from "../components/modals/KKK/DeleteKKKItemModal";
import UpdateKKKItemModal from "../components/modals/KKK/UpdateKKKItemModal";
import AddKKKItemModal from "../components/modals/KKK/AddKKKItemModal";
import AddLoadYukKaydiModal from "../components/modals/load/AddLoadYukKaydiModal";
import DeleteLoadRoutePermissionModal from "../components/modals/load/DeleteLoadRoutePermissionModal";
import DeleteLoadPaketlemeItemPermissionModal from "../components/modals/load/DeleteLoadPaketlemeItemPermissionModal";
import LoadSigortaMusteriTemsilcisiModal from "../components/modals/load/LoadSigortaMusteriTemsilcisiModal";
import LoadAracAdetModal from "../components/modals/load/LoadAracAdetModal";
import LoadSigortaTeklifModal from "../components/modals/load/LoadSigortaTeklifModal";
import AddLoadYuklemeSecenekleriModal from "../components/modals/load/AddLoadYuklemeSecenekleriModal";
import MapChangesModal from "../components/modals/load/MapChangesModal";
import MapDeleteRoute from "../components/modals/load/MapDeleteRoute";
import ClearPermisisonLoadDataPieceModal from "../components/modals/load/ClearPermisisonLoadDataPieceModal";
import ContinueModal from "../components/modals/ContinueModal";
import LoadYetkiliBilgiFormModal from "../components/modals/loadUpdate/LoadYetkiliBilgiFormModal";
import UpdateLoadModal from "../components/modals/loadUpdate/UpdateLoadModal";
import DeleteLoadPermissionModal from "../components/modals/load/DeleteLoadPermissionModal";
import DeleteLoadRoutePermissionNestedModal from "../components/modals/loadUpdate/DeleteLoadRoutePermissionNestedModal";
import DateControlModal from "../components/modals/DateControlModal";
import DeleteLoadPaketlemeItemPermissionNestedModal from "../components/modals/loadUpdate/DeleteLoadPaketlemeItemPermissionNestedModal";
import AddTopluYukModal from "../components/modals/load/AddTopluYukModal";
import DateAfterControlModal from "../components/modals/dateAfterControlModal";
import BeforeDateControlModal from "../components/modals/beforeDateControlModal";
import SurucuProfilDegerlendirModal from "../components/modals/surucuProfilDegerlendir";
import SurucuDegerlendirmeBilgiModal from "../components/modals/SurucuDegerlendirmeBilgiModal";
import AddAIQuestionModal from "../components/modals/ai/AddAIQuestionModal";
import UpdateAIQuestionsModal from "../components/modals/ai/UpdateAIQuestionsModal";
import ShipmentIrsaliyeModal from "../components/modals/load/ShipmentIrsaliyeModal";
import AddJoblistVehicleModal from "../components/modals/joblistModals/addJoblistVehicleModal";
import InsertionQuestionModal from "../components/modals/joblistModals/InsertionQuestionModal";
import AddQueueVehicleModal from "../components/modals/joblistModals/AddQueueVehicleModal";
import JobListInviteModal from "../components/modals/joblistModals/JobListInviteModal";
import JobSmsModal from "../components/modals/joblistModals/JobSmsModal";
import JobListAccessModal from "../components/modals/joblistModals/JobListAccessModal";
import AddAiChatSubTitleModal from "../components/modals/ai/AddAiChatSubTitleModal";
import AddAiChatTitleModal from "../components/modals/ai/AddAiChatTitleModal";
import DeleteAiChatTitlePermissionModal from "../components/modals/ai/DeleteAiChatTitlePermissionModal";
import UpdateAiChatTitleModal from "../components/modals/ai/UpdateAiChatTitleModal";
import UpdateAiSingleQuestionItemModal from "../components/modals/ai/UpdateAiSingleQuestionItemModal";
import ShowMektupModal from "../components/modals/jobList/ShowMektupModal";
import JobListBirebirEslestirResultModal from "../components/modals/jobList/JobListBirebirEslestirResultModal";
import JobListDriverAssignmentModal from "../components/modals/jobList/JobListDriverAssignmentModal";
import DevamliAraclarDavetModal from "../components/modals/joblistModals/DevamliAraclarDavetModal";
import DevamliAraclarAracListelemeModal from "../components/modals/devamliAraclar/DevamliAraclarAracListelemeModal";
import DevamliAraclarSiraListelemeModal from "../components/modals/devamliAraclar/DevamliAraclarSiraListelemeModal";
import DevamliAraclarIsListelemeModal from "../components/modals/devamliAraclar/DevamliAraclarIsListelemeModal";
import UpdateAiChatSubTitleModal from "../components/modals/ai/UpdateAiChatSubTitleModal";
import DevamliAracDeleteModal from "../components/modals/devamliAraclar/DevamliAracDeleteModal";
import UpdateAiOrderModal from "../components/modals/ai/UpdateAiOrderModal";
import UpdateAiSubTitleOrderModal from "../components/modals/ai/UpdateAiSubTitleOrderModal";
import AdminUyeEkleModal from "../components/modals/adminUyeler/AdminUyeEkleModal";
import AdminTopluUyeEkleModal from "../components/modals/adminUyeler/AdminTopluUyeEkleModal";
import FirmalarFirmaEkleModal from "../components/modals/firmalarim/FirmalarFirmaEkleModal";
import FirmalarimDetayModal from "../components/modals/firmalarim/FirmalarimDetayModal";
import AdminUyeGuncelleModal from "../components/modals/adminUyeler/AdminUyeGuncelleModal";
import AdminAraclarTekliAracEkle from "../components/modals/adminAraclar/AdminAraclarTekliAracEkle";
import AdminAraclarİslemlerOptions from "../components/modals/adminAraclar/AdminAraclarİslemlerOptions";
import AdminAraclarCezaSorgulaModal from "../components/modals/adminAraclar/AdminAraclarCezaSorgulaModal";
import AdminAraclarYetkiBelgesiModal from "../components/modals/adminAraclar/AdminAraclarYetkiBelgesiModal";
import AdminAraclarMuayeneModal from "../components/modals/adminAraclar/AdminAraclarMuayeneModal";
import AdminAracGuncelleModal from "../components/modals/adminAraclar/AdminAracGuncelleModal";
import AdminTopluAracEkleModal from "../components/modals/adminAraclar/AdminTopluAracEkleModal";
import KayitliAdresEkleNewModal from "../components/modals/KayitliAdresEkleNewModal";
import AdminUyeItemOptionsModal from "../components/modals/adminUyeler/AdminUyeItemOptionsModal";
import ShipmentIrsaliyeWideModal from "../components/modals/load/ShipmentIrsaliyeWideModal";
import UpdateAiChatTitleActivityModal from "../components/modals/ai/UpdateAiChatTitleActivityModal";
import KayitliYukEkleNewModal from "../components/modals/kayitİslemleri/KayitliYukEkleNewModal";
import AddLoadYuklemeSecenekleriForKayitModal from "../components/modals/kayitİslemleri/AddLoadYuklemeSecenekleriForKayit";
import UpdateAiChatSubTitleActivityModal from "../components/modals/ai/UpdateAiChatSubTitleActivityModal";
import AdminUyeninSuruculerModal from "../components/modals/adminUyeler/AdminUyeninSuruculerModal";
import AdminAraclarAracSil from "../components/modals/adminAraclar/AdminAraclarAracSilModal";
import AdminAraclarBelgeIslemler from "../components/modals/adminAraclar/AdminAraclarBelgeIslemlerModal";
import AdminDorseBelgeIslemler from "../components/modals/adminAraclar/AdminDorseBelgeIslemlerModal";
import AdminAracDetayModal from "../components/modals/adminAraclar/AdminAracDetayModal";
import AdminAddUyeSurucuModal from "../components/modals/adminUyeler/AdminAddUyeSurucuModal";
import AdminUyeDetayModal from "../components/modals/adminUyeler/AdminUyeDetayModal";
import CreateUETDSModal from "../components/modals/UETDSModals/CreateUETDSModal";
import UETDSGonderilmisDetayModal from "../components/modals/UETDSGonderilmisDetayModal";
import FirmalarimMap from "../components/modals/firmalarim/FirmalarimMap";
import FirmalarimUpdateMap from "../components/modals/firmalarim/FirmalarUpdateMap";
import NestedResultModal from "../components/modals/NestedResultModal";
import AdminUyeTCDogrulaModal from "../components/modals/adminUyeler/AdminUyeTCDogrulaModal";
import LoadPermissionErrorModal from "../components/modals/LoadPermissionErrorModal";
import UpdateUETDSModal from "../components/modals/UETDSModals/UpdateUETDSModal";
import NakliyeIndexCityToCityAddExcelModal from "../components/modals/nakliyeIndex/NakliyeIndexCityToCityAddExcelModal";
import NakliyeIndexCityAddExcelModal from "../components/modals/nakliyeIndex/NakliyeIndexCityAddExcelModal";
import NakliyeIndexCityToTownAddExcelModal from "../components/modals/nakliyeIndex/NakliyeIndexCityToTownAddExcelModal";
import NakliyeIndexCityTownIklimAddExcelModal from "../components/modals/nakliyeIndex/NakliyeIndexCityTownIklimAddExcelModal";
import NakliyeIndexCitySeasonAddExcelModal from "../components/modals/nakliyeIndex/NakliyeIndexCitySeasonAddExcelModal";
import DevamliAraclarAldigiIsListelemeModal from "../components/modals/devamliAraclar/DevamliAraclarAldigiIsListelemeModal";
import AddProfilimKullaniciModal from "../components/modals/profilim/AddProfilimKullaniciModal";
import AddProfilimSuruculerimModal from "../components/modals/profilim/AddProfilimSuruculerimModal";
import ProfilAltKullaniciOptionsModal from "../components/modals/profilim/ProfilAltKullaniciOptionsModal";
import UpdateKullaniciRolYetkiModal from "../components/modals/profilim/UpdateKullaniciRolYetkiModal";
import KayitliAdresMapModal from "../components/modals/KayitliAdresMapModal";
import KayitliAdresGuncelleModal from "../components/modals/KayitliAdresGuncelleModal";
import KayitliAdresPolygonMapModal from "../components/modals/KayitliAdresPolygonMapModal";
import SigortaReklamGörselModal from "../components/modals/sigorta/SigortaReklamGörselModal";
import TeklifRejectReasonModal from "../components/modals/topPages/TeklifRejectReasonModal";
import CompanyAracItemModal from "../components/modals/profilim/CompanyAracItemModal";
import GibInfoModal from "../components/modals/GibInfoModal";
import ProfilAracCloseModal from "../components/modals/profilim/ProfilAracCloseModal";
import ProfilSearchSurucuModal from "../components/modals/profilim/ProfilSearchSurucuModal";
import ProfilSurucuSearchDetailModal from "../components/modals/profilim/ProfilSurucuSearchDetailModal";
import FirmaBilgileriSelectMapModal from "../components/modals/profilim/FirmaBilgileriSelectMapModal";
import AddLoadMapWideModal from "../components/modals/load/AddLoadMapWideModal";
import GibLoginModal from "../components/modals/gib/GibLoginModal";
import GibFaturaDetailHtmlModal from "../components/modals/gib/GibFaturaDetailHtmlModal";
import GibKestigimFaturaSmsVerificationModal from "../components/modals/gib/GibKestigimFaturaSmsVerificationModal";
import DeleteGibEarsivInvoiceModal from "../components/modals/gib/DeleteGibEarsivInvoiceModal";
import AddRentalCarModal from "../components/modals/ilanlar/AddRentalCarModal";
import AdvertReasonForDeleteModal from "../components/modals/ilanlar/AdvertReasonForDeleteModal";
import AdvertRentalCarUpdateModal from "../components/modals/ilanlar/AdvertRentalCarUpdateModal";
import AddDriverSeekerModal from "../components/modals/ilanlar/AddDriverSeekerModal";
import DriverSeekerDeleteModal from "../components/modals/ilanlar/DriverSeekerDeleteModal";
import DriverSeekerUpdateModal from "../components/modals/ilanlar/DriverSeekerUpdateModal";
import AddVehiclesForSaleModal from "../components/modals/ilanlar/AddVehiclesForSaleModal";
import DeleteVehiclesForSaleModal from "../components/modals/ilanlar/DeleteVehiclesForSaleModal";
import UpdateVehiclesForSaleModal from "../components/modals/ilanlar/UpdateVehiclesForSaleModal";
import AdvertShowPhotoModal from "../components/modals/ilanlar/AdvertShowPhotoModal";
import ReqResModal from "../components/modals/sistemIslemKayitlari/ReqResModal";
import CancelGibEarsivInvoiceModal from "../components/modals/gib/CancelGibEarsivInvoiceModal";
import EArsivKayitliMusteriEkleModal from "../components/modals/eArsiv/EArsivKayitliMusteriEkleModal";
import UyelerVeAraclarUyeEkleModal from "../components/modals/uyelerVeAraclar/UyelerVeAraclarUyeEkleModal";
import KooperatifUyeDetayModal from "../components/modals/uyelerVeAraclar/KooperatifUyeDetayModal";
import KooperatifTopluUyeEkleModal from "../components/modals/uyelerVeAraclar/KooperatifTopluUyeEkleModal";
import KooperatifAraclarTekliAracEkle from "../components/modals/uyelerVeAraclar/KooperatifAraclarTekliAracEkle";
import KooperatifAracGuncelleModal from "../components/modals/uyelerVeAraclar/KooperatifAracGuncelleModal";
import KooperatifAraclarBelgeIslemlerModal from "../components/modals/uyelerVeAraclar/KooperatifAraclarBelgeIslemlerModal";
import KooperatifAraclarOptionsModal from "../components/modals/uyelerVeAraclar/KooperatifAraclarOptionsModal";
import KooperatifDorseBelgeIslemlerModal from "../components/modals/uyelerVeAraclar/KooperatifDorseBelgeIslemlerModal";
import KooperatifAracDetayModal from "../components/modals/uyelerVeAraclar/KooperatifAracDetayModal";
import KooperatifTopluAracEkleModal from "../components/modals/uyelerVeAraclar/KooperatifTopluAracEkleModal";
import IletisimBilgileriModal from "../components/modals/IletisimBilgileriModal";
import DeletePermissionBolgedekiTeklifItemModal from "../components/modals/bolgedekiTekliflerim/DeletePermissionBolgedekiTeklifItemModal";
import UpdatePermissionCloseBolgedekiTeklifModal from "../components/modals/bolgedekiTekliflerim/UpdatePermissionCloseBolgedekiTeklifModal";
import LoadOwnerProfileModal from "../components/modals/loadOwner/LoadOwnerProfileModal";
import LoadOwnerImageModal from "../components/modals/loadOwner/LoadOwnerImageModal";
import YukVerenKayitModal from "../components/modals/isOrtaklariModals/YukVerenKayitModal";
import ProjeOlusturModal from "../components/modals/isOrtaklariModals/ProjeOlusturModal";
import TopPagesWideMapModal from "../components/modals/topPages/TopPagesWideMapModal";
import YukKaydiRaporModal from "../components/modals/raporlar/YukKaydiRaporModal";
import OrtalamaAracTedarikModal from "../components/modals/raporlar/OrtalamaAracTedarikModal";
import ArsivYukveGerekceModal from "../components/modals/raporlar/ArsivYukveGerekceModal";
import EnUzunSureliBosaltmaModal from "../components/modals/raporlar/EnUzunSureliBosaltmaModal";
import EnUzunSureliYuklemeModal from "../components/modals/raporlar/EnUzunSureliYuklemeModal";
import TopPagesTamamlananWideMapModal from "../components/modals/topPages/TopPagesTamamlananWideMapModal";
import MobileMenuModal from "../components/modals/mobile/MobileMenuModal";
import UpdateDevamliAracModal from "../components/modals/devamliAraclar/UpdateDevamliAracModal";
import FirmaKaraListeOptionModal from "../components/modals/FirmaKaraListeOptionModal";
import AdresKayitItemOptionsModal from "../components/modals/adresKayit/AdresKayitItemOptionsModal";
import YukKayitItemOptionsModal from "../components/modals/adresKayit/YukKayitItemOptionsModal";
import YuklemeSureleriModal from "../components/modals/raporlar/YuklemeSureleriModal";
import BosaltmaSureleriModal from "../components/modals/raporlar/BosaltmaSureleriModal";
import AddRentalCarSeekersModal from "../components/modals/ilanlar/AddRentalCarSeekers";
import ProjeDetayModal from "../components/modals/isOrtaklariModals/ProjeDetayModal";
import AddLoadKayitResponseModal from "../components/modals/load/AddLoadKayitResponseModal";
import LoadUpdateYayinlamaSecenekleriModal from "../components/modals/loadUpdate/LoadUpdateYayinlamaSecenekleriModal";
import DeleteLoadOwnerModal from "../components/modals/isOrtaklariModals/DeleteLoadOwnerModal";
import AddLoadYetkiliBilgiFormModal from "../components/modals/load/AddLoadYetkiliBilgiFormModal";
import LoadYetkiliBilgiFormInfoModal from "../components/modals/loadUpdate/LoadYetkiliBilgiFormInfoModal";
import SingleRouteMapModal from "../components/modals/load/SingleRouteMapModal";
import AddLoadRouteItemNotSavedDescModal from "../components/modals/load/AddLoadRouteItemNotSavedDescModal";
import SingleRouteMapUpdateModal from "../components/modals/loadUpdate/SingleRouteMapUpdateModal";
import ShowMektupShipmentModal from "../components/modals/topPages/ShowMektupShipmentModal";
import AddLoadSuccessModal from "../components/modals/load/AddLoadSuccessModal";
import KayitliYukGuncelleModal from "../components/modals/kayitİslemleri/KayitliYukGuncelleModal";
import AddDriverAndVehicleModal from "../components/modals/joblistModals/AddDriverAndVehicleModal";
import AiPanelSingleChatDetailsModal from "../components/modals/ai/AiPanelSingleChatDetailsModal";
import AiMobileSingleChatDetailsModal from "../components/modals/ai/AiMobileSingleChatDetailsModal";
import FreightInfoModal from "../components/modals/FreightInfoModal";
import RentalCarOptionsModal from "../components/modals/ilanlar/RentalCarOptionsModal";
import AdminRentalCarOptionsModal from "../components/modals/adminİlanlar/AdminRentalCarOptionsModal";
import AdminRentalCarDeleteModal from "../components/modals/adminİlanlar/AdminRentalCarDeleteModal";
import AdminRentalCarUpdateModal from "../components/modals/adminİlanlar/AdminRentalCarUpdateModal";
import RentalCarSeekerOptionsModal from "../components/modals/ilanlar/RentalCarSeekerOptionsModal";
import UpdateRentalCarSeekerModal from "../components/modals/ilanlar/UpdateRentalCarSeekerModal";
import DeleteRentalCarSeekerModal from "../components/modals/ilanlar/DeleteRentalCarSeekerModal";
import AdminRentalCarSeekerOptionsModal from "../components/modals/adminİlanlar/AdminRentalCarSeekerOptionsModal";
import AdminRentalCarSeekerDeleteModal from "../components/modals/adminİlanlar/AdminRentalCarSeekerDeleteModal";
import AdminRentalCarSeekerUpdateModal from "../components/modals/adminİlanlar/AdminRentalCarSeekerUpdateModal";
import AdminDriverJobSeekerOptionsModal from "../components/modals/adminİlanlar/AdminDriverJobSeekerOptionsModal";
import AdminDriverJobSeekerUpdateModal from "../components/modals/adminİlanlar/AdminRentalCarUpdateModal";
import AdminDriverJobSeekerDeleteModal from "../components/modals/adminİlanlar/AdminDriverJobSeekerDeleteModal";
import DriverSeekerOptionsModal from "../components/modals/ilanlar/DriverSeekerOptionsModal";
import AdminDriverSeekerOptionsModal from "../components/modals/adminİlanlar/AdminDriverSeekerOptionsModal";
import AdminDriverSeekerDeleteModal from "../components/modals/adminİlanlar/AdminDriverSeekerDeleteModal";
import AdminDriverSeekerUpdateModal from "../components/modals/adminİlanlar/AdminDriverSeekerUpdateModal";
import PublishingType2Modal from "../components/modals/topPages/PublishingType2Modal";
import PublishingType2UpdateModal from "../components/modals/loadUpdate/PublishingType2UpdateModal";
import AllLoadBulkModal from "../components/modals/load/AllLoadBulkModal";
import CreateUETDSForLogisticModal from "../components/modals/UETDSModals/CreateUETDSForLogisticModal";
import UpdateUETDForLogisticModal from "../components/modals/UETDSModals/UpdateUETDForLogisticModal";
import ShareLocationTrackingModal from "../components/modals/topPages/ShareLocationTrackingModal";
import CompleteShipmentsPermissionModal from "../components/modals/topPages/CompleteShipmentsPermissionModal";
import UpdateShipmentContainerAndSealNumbersModal from "../components/modals/topPages/UpdateShipmentContainerAndSealNumbersModal";
import DeleteShipmentPermissionModal from "../components/modals/topPages/DeleteShipmentPermissionModal";
import UpdateShipmentVehicleModal from "../components/modals/topPages/UpdateShipmentVehicleModal";
import AdminKaraListeSonucModal from "../components/modals/adminKaraListe/AdminKaraListeSonucModal";
import AddKarayollariIstasyonModal from "../components/modals/karayollari/AddKarayollariIstasyonModal";
import UpdateKarayollariIstasyonModal from "../components/modals/karayollari/UpdateKarayollariIstasyonModal";
import UetdsControlUpdateModal from "../components/modals/UetdsControlUpdateModal";
import AddFerryPricesModal from "../components/modals/nakliyeHesaplama/AddFerryPricesModal";
import AddBridgePricesModal from "../components/modals/nakliyeHesaplama/AddBridgePricesModal";
import NakliyeHesaplamaGuideModal from "../components/modals/nakliyeHesaplama/NakliyeHesaplamaGuideModal";
import AdminKaralisteTelefonEkleModal from "../components/modals/adminKaraListe/AdminKaralisteTelefonEkleModal";
import DeleteScheduledNotificationPermissionModal from "../components/modals/notifications/DeleteScheduledNotificationPermissionModal";
import CreateRoadRouteModal from "../components/modals/karayollari/CreateRoadRouteModal";
import RoadRouteOptionsModal from "../components/modals/karayollari/RoadRouteOptionsModal";
import CreateThirdRoadRouteModal from "../components/modals/karayollari/CreateThirdRoadRouteModal";
import UpdateRoadRouteModal from "../components/modals/karayollari/UpdateRoadRouteModal";
import AddYukBulBlockingMessageModal from "../components/modals/yukBulBlocking/AddYukBulBlockingMessageModal";
import DeleteYukbulBlockingMessageConfirmModal from "../components/modals/yukBulBlocking/DeleteYukbulBlockingMessageConfirmModal";
import YukBulDeletePermissionModal from "../components/modals/yukBul/YukBulDeletePermissionModal";
import YukBulShareMessagesModal from "../components/modals/yukBul/YukBulShareMessagesModal";
import AdminYukAriyorumModal from "../components/modals/yukBul/AdminYukAriyorumModal";
import AddProfilimAraclarimModal from "../components/modals/profilim/AddProfilimAraclarimModal";
import UetdsExcelSpecialModal from "../components/modals/UETDSModals/UetdsExcelSpecialModal";
import AraclarYetkiBelgesiResultModal from "../components/modals/yukIslemleri/AraclarYetkiBelgesiResultModal";
import AraclarMuayeneResultModal from "../components/modals/yukIslemleri/AraclarMuayeneResultModal";
import FastLoadModal from "../components/modals/load/FastLoadModal";
import AdminDeletePageModal from "../components/modals/AdminDeletePageModal";
import PortalMembersControlUpdateModal from "../components/modals/adminPortalMembers/PortalMembersControlUpdateModal";
import PortalMemberRejectedReasonModal from "../components/modals/adminPortalMembers/PortalMemberRejectedReasonModal";
import AiMobileNewModelSingleChatDetailsModal from "../components/modals/ai/AiMobileNewModelSingleChatDetailsModal";
import AddDriverPhoneNumberExistingDescModal from "../components/modals/driversVehicles/AddDriverPhoneNumberExistingDescModal";
import AddDriverAfterVehicleQuestionModal from "../components/modals/driversVehicles/AddDriverAfterVehicleQuestionModal";
import AddRegularDriverModal from "../components/modals/driversVehicles/AddRegularDriverModal";
import AddRegularDriversVehicleModal from "../components/modals/driversVehicles/AddRegularDriversVehicleModal";
import RegularDriverItemDetailsModal from "../components/modals/driversVehicles/RegularDriverItemDetailsModal";
import AddRegularDriverPhoneNumberQueryModal from "../components/modals/driversVehicles/AddRegularDriverPhoneNumberQueryModal";
import UpdateRegularDriverRefAndRegularModal from "../components/modals/driversVehicles/UpdateRegularDriverRefAndRegularModal";
import AddJobListRegularVehiclePhoneNumberQueryModal from "../components/modals/driversVehicles/AddJobListRegularVehiclePhoneNumberQueryModal";
import AddDailyQueueModal from "../components/modals/driversVehicles/AddDailyQueueModal";
import RegularVehicleListModal from "../components/modals/driversVehicles/RegularVehicleListModal";
import ShipmentOperationModal from "../components/modals/shipmentOperation/ShipmentOperationModal";
import ShipmentRouteOperationModal from "../components/modals/shipmentOperation/ShipmentRouteOperationModal";
import AdminDeleteBlogPermissionModal from "../components/modals/yukIslemleri/AdminDeleteBlogPermissionModal";
import AdminDeleteMultiBlogPermissionModal from "../components/modals/yukIslemleri/AdminDeleteMultiBlogPermissionModal";
import SevkiyatRaporuModal from "../components/modals/raporlar/SevkiyatRaporuModal";
import GumrukAgcModal from "../components/modals/gumrukAgc/GumrukAgcModal";



const ModalLayout = () => {
  const { modalType, nestedModalType } = useSelector((state) => state.modal);
  const gumrukAgcOperationId = useSelector((state) => state.gumrukAgc.operationId);


  return (
    <>

      {gumrukAgcOperationId && <GumrukAgcModal />}

      {modalType === "addLoadMapWide" && <AddLoadMapWideModal/>}

      {modalType === "logoutVerification" && <LogoutVerificationModal />}

      {modalType === "image" && <ImageModal />}

      {modalType === "updateUETDS" && <UpdateUETDSModal />}

      {modalType === "uetdsExcelSpecial" && <UetdsExcelSpecialModal />}

      {modalType === "createUETDS" && <CreateUETDSModal /> }

      {modalType === "createUETDSForLogistic" && <CreateUETDSForLogisticModal /> }

      {modalType === "updateUETDForLogistic" && <UpdateUETDForLogisticModal /> }

      {modalType === "uetdsGonderilmisDetay" && <UETDSGonderilmisDetayModal /> }

      {modalType === "result" && <ResultModal />}

      {modalType === "ContinueModal" && <ContinueModal />}

      {modalType === "updateEgeyurtIletisimItem" && <UpdateEgeyurtIletisimItemModal />}

      {modalType === "addEgeyurtIletisimItem" && <AddEgeyurtIletisimItemModal /> }

      {modalType === "deleteEgeYurtIletisimBirim" && <DeleteEgeyurtIletisimBirimPermissionModal /> }

      {modalType === "deleteAnasayfaDuyuruItem" && <DeleteAnasafaDuyuruItemPermissionModal /> }

      {modalType === "iletisimBilgileri" && <IletisimBilgileriModal />}
      
      {modalType === "uyeMeslekiYeterlilik" && <UyeMeslekiYeterlilikModal />}

      {modalType === "adminTopluAracEkleModal" && <AdminTopluAracEkleModal />}

      {modalType === "adminAraclarTekliAracEkle" && <AdminAraclarTekliAracEkle />}

      {modalType === "adminAraclarİslemlerOptions" && <AdminAraclarİslemlerOptions />}

      {modalType === "adminAraclarCezaSorgulaModal" && <AdminAraclarCezaSorgulaModal />}

      {modalType === "adminAraclarYetkiBelgesiModal" && <AdminAraclarYetkiBelgesiModal />}

      {modalType === "adminAraclarMuayeneModal" && <AdminAraclarMuayeneModal />}

      {modalType === "adminAracGuncelle" && <AdminAracGuncelleModal />}

      {modalType === "adminAraclarBelgeIslemler" && <AdminAraclarBelgeIslemler /> }

      {modalType === "adminDorseBelgeIslemler" && <AdminDorseBelgeIslemler /> }

      {modalType === "adminAracDetay" && <AdminAracDetayModal /> }

      {modalType === "adminYukAriyorum" && <AdminYukAriyorumModal />}

      {modalType === "uyeIslemleriOptions" && <UyeIslemleriOptionsModal />}

      {modalType === "uyeIsvereni" && <UyeIsvereniModal />}

      {modalType === "aracMuayeneSorgu" && <AracMuayeneSorguModal />}

      {modalType === "resultErrAracMuayene" && <ResultErrAracMuayeneModal />}

      {modalType === "aracYetkiBelgesiSorgu" && <AracYetkiBelgesiSorguModal />}

      {modalType === "aracCezaSorgu" && <AracCezaSorguModal />}

      {modalType === "kayitliAdresEkleYeni" && <KayitliAdresEkleNewModal />}

      {modalType === "kayitliAdresGuncelle" && <KayitliAdresGuncelleModal />}

      {modalType === "kayitliYukNewEkle" && <KayitliYukEkleNewModal />}

      {modalType === "kayitliYukGuncelle" && <KayitliYukGuncelleModal />}

      {modalType === "sigortaTeklifAlResult" && <SigortaTeklifAlResultModal />}

      {modalType === "addProfilimAraclarim" && <AddProfilimAraclarimModal />}

      {modalType === "profilAltKullaniciOptions" && <ProfilAltKullaniciOptionsModal />}

      {modalType === "addProfilimSuruculerim" && <AddProfilimSuruculerimModal />}

      {modalType === "profilSearchSurucu" && <ProfilSearchSurucuModal />}

      {modalType === "addProfilimKullanici" && <AddProfilimKullaniciModal />}

      {modalType === "profilSurucuSearchDetail" && <ProfilSurucuSearchDetailModal />}

      {modalType === "addFerryPrices" && <AddFerryPricesModal/>}

      {modalType === "addBridgePrices" && <AddBridgePricesModal/>}

      {modalType === "nakliyeHesaplamaGuide" && <NakliyeHesaplamaGuideModal/>}

      {modalType === "kullaniciRolYetkiUpdate" && <UpdateKullaniciRolYetkiModal />}

      {modalType === "uetdsControlUpdate" && <UetdsControlUpdateModal />}

      {modalType === "firmaKaraListeEkle" && <FirmaKaraListeEkleModal />}

      {modalType === "firmaKaraListeOption" && <FirmaKaraListeOptionModal />}

      {modalType === "adminKaraListeEkle" && <AdminKaraListeEkleModal />}

      {modalType === "adminKaraListeSonuc" && <AdminKaraListeSonucModal />}

      {modalType === "adminKaralisteTelefonEkle" && <AdminKaralisteTelefonEkleModal />}

      {modalType === "search" && <SearchModal />}

      {modalType === "garajDetay" && <GarajDetayModal />}

      {modalType === "adminSettingsPermission" && <AdminSettingsPermissionModal /> }

      {modalType === "addSSSItem" && <AddSSSItemModal />}

      {modalType === "updateSSSItem" && <UpdateSSSItemModal />}

      {modalType === "deleteSSSItem" && <DeleteSSSItemModal />}

      {modalType === "addKKKItem" && <AddKKKItemModal />}

      {modalType === "updateKKKItem" && <UpdateKKKItemModal />}

      {modalType === "deleteKKKItem" && <DeleteKKKItemModal />}

      {modalType === "addLoadYukKaydi" && <AddLoadYukKaydiModal />}

      {modalType === "addLoadSuccess" && <AddLoadSuccessModal />}

      {modalType === "addLoadYetkiliBilgiForm" && <AddLoadYetkiliBilgiFormModal />}

      {modalType === "addLoadYuklemeSecenekleri" && <AddLoadYuklemeSecenekleriModal /> }

      {modalType === "loadYetkiliBilgiForm" && <LoadYetkiliBilgiFormModal />}

      {modalType === "loadYetkiliBilgiFormInfo" && <LoadYetkiliBilgiFormInfoModal />}

      {modalType === "updateLoad" && <UpdateLoadModal />}

      {modalType === "loadUpdateYayinlamaSecenekleri" && <LoadUpdateYayinlamaSecenekleriModal />}

      {modalType === "deleteLoadPermission" && <DeleteLoadPermissionModal />}

      {nestedModalType === "deleteLoadRoutePermission" && <DeleteLoadRoutePermissionModal />}

      {modalType === "deleteLoadPaketlemeItemPermission" && <DeleteLoadPaketlemeItemPermissionModal />}

      {modalType === "loadSigortaMusteriTemsilcisi" && <LoadSigortaMusteriTemsilcisiModal />}

      {modalType === "loadAracAdet" && <LoadAracAdetModal />}

      {modalType === "loadSigortaTeklif" && <LoadSigortaTeklifModal />}

      {nestedModalType === "singleRouteMap" && <SingleRouteMapModal />}

      {modalType === "addTopluYuk" && <AddTopluYukModal />}

      {modalType === "addAIQuestion" && <AddAIQuestionModal />}

      {modalType === "addAiChatSubTitle" && <AddAiChatSubTitleModal />}

      {modalType === "addAiChatTitle" && <AddAiChatTitleModal />}

      {modalType === "updateAIQuestions" && <UpdateAIQuestionsModal />}

      {modalType === "deleteAiChatTitlePermission" && <DeleteAiChatTitlePermissionModal />}

      {modalType === "updateAiSingleQuestionItem" && <UpdateAiSingleQuestionItemModal />}

      {modalType === "updateAiChatTitle" && <UpdateAiChatTitleModal />}

      {modalType === "updateAISubTitle" && <UpdateAiChatSubTitleModal />}

      {modalType === "updateAiOrder" && <UpdateAiOrderModal />}

      {modalType === "updateAiChatTitleActivity" && <UpdateAiChatTitleActivityModal />}

      {modalType === "updateAiChatSubTitleActivity" && <UpdateAiChatSubTitleActivityModal />}

      {modalType === "aiMobileSingleChatDetails" && <AiMobileSingleChatDetailsModal />}

      {modalType === "aiMobileNewModelSingleChatDetails" && <AiMobileNewModelSingleChatDetailsModal />}

      {modalType === "aiPanelSingleChatDetails" && <AiPanelSingleChatDetailsModal />}

      {modalType === "shipmentIrsaliye" && <ShipmentIrsaliyeModal />}

      {modalType === "addQueueVehicle" && <AddQueueVehicleModal />}

      {modalType === "addJoblistVehicle" && <AddJoblistVehicleModal />}

      {modalType === "addDriverAndVehicle" && <AddDriverAndVehicleModal />}

      {modalType === "JobListInviteModal" && <JobListInviteModal />}

      {modalType === "DevamliAraclarDavetModal" && <DevamliAraclarDavetModal />}

      {/* //! kullanıp kullanılmadığı bakılacak */}
      {modalType === "JobListAccessModal" && <JobListAccessModal />}

      {modalType === "JobSmsModal" && <JobSmsModal />}

      {modalType === "showMektup" && <ShowMektupModal />}

      {modalType === "showMektupShipment" && <ShowMektupShipmentModal />}

      {modalType === "jobListBirebirEslestirResult" && <JobListBirebirEslestirResultModal />}

      {modalType === "jobListDriverAssignment" && <JobListDriverAssignmentModal />}

      {modalType === "firmalarFirmaEkleModal" && <FirmalarFirmaEkleModal /> }

      {modalType === "firmalarimDetayModal" && <FirmalarimDetayModal /> }


      {modalType === "devamliAraclarSiraListeleme" && <DevamliAraclarSiraListelemeModal />}

      {modalType === "devamliAraclarIsListeleme" && <DevamliAraclarIsListelemeModal />}

      {modalType === "devamliAraclarAldigiIsListeleme" && <DevamliAraclarAldigiIsListelemeModal />}

      {modalType === "DevamliAracDeleteModal" && <DevamliAracDeleteModal />}

      {modalType === "updateDevamliArac" && <UpdateDevamliAracModal />}
      
      {modalType === "insertionQuestionModal" && <InsertionQuestionModal />}

      {modalType === "adminUyeEkle" && <AdminUyeEkleModal />}

      {modalType === "adminTopluUyeEkle" && <AdminTopluUyeEkleModal />}

      {modalType === "adminUyeGuncelle" && <AdminUyeGuncelleModal />}

      {modalType === "adminUyeOptions" && <AdminUyeItemOptionsModal />}

      {modalType === "adminUyeninSuruculer" && <AdminUyeninSuruculerModal />}

      {modalType === "adminAddUyeSurucu" && <AdminAddUyeSurucuModal />}

      {modalType === "adminUyeDetay" && <AdminUyeDetayModal />}

      {modalType === "adminUyeTCDogrula" && <AdminUyeTCDogrulaModal />}

      {modalType === "loadPermissionError" && <LoadPermissionErrorModal />}

      {modalType === "nakliyeIndexCityAddExcel" && <NakliyeIndexCityAddExcelModal />}

      {modalType === "nakliyeIndexCitySeasonAddExcel" && <NakliyeIndexCitySeasonAddExcelModal />}

      {modalType === "nakliyeIndexCityToCityAddExcel" && <NakliyeIndexCityToCityAddExcelModal />}

      {modalType === "nakliyeIndexCityToTownAddExcel" && <NakliyeIndexCityToTownAddExcelModal />}

      {modalType === "nakliyeIndexCityTownIklimAddExcel" && <NakliyeIndexCityTownIklimAddExcelModal />}
      
      {modalType === "sigortaReklamGorsel" && <SigortaReklamGörselModal />}

      {modalType === "teklifRejectReason" && <TeklifRejectReasonModal />}
      
      {modalType === "companyAracItem" && <CompanyAracItemModal />}

      {modalType === "gibInfo" && <GibInfoModal />}

      {modalType === "gibLogin" && <GibLoginModal />}

      {modalType === "gibFaturaDetailHtml" && <GibFaturaDetailHtmlModal />}
      
      {modalType === "gibKestigimFaturaSmsVerification" && <GibKestigimFaturaSmsVerificationModal />}

      {modalType === "deleteGibEarsivInvoice" && <DeleteGibEarsivInvoiceModal />}

      {modalType === "cancelGibEarsivInvoice" && <CancelGibEarsivInvoiceModal />}

      {modalType === "eArsivKayitliMusteriEkle" && <EArsivKayitliMusteriEkleModal />}

      {modalType === "addRentalCar" && <AddRentalCarModal />}

      {modalType === "addRentalCarSeekers" && <AddRentalCarSeekersModal />}

      {modalType === "advertReasonForDelete" && <AdvertReasonForDeleteModal />}

      {modalType === "advertRentalCarUpdate" && <AdvertRentalCarUpdateModal />}

      {modalType === "addDriverSeeker" && <AddDriverSeekerModal />}

      {modalType === "driverSeekerDelete" && <DriverSeekerDeleteModal />}

      {modalType === "driverSeekerUpdate" && <DriverSeekerUpdateModal />}

      {modalType === "driverSeekerOptions" && <DriverSeekerOptionsModal />}

      {modalType === "addVehiclesForSale" && <AddVehiclesForSaleModal />}

      {modalType === "updateVehiclesForSale" && <UpdateVehiclesForSaleModal />}
      
      {modalType === "deleteVehiclesForSale" && <DeleteVehiclesForSaleModal />}

      {modalType === "advertShowPhoto" && <AdvertShowPhotoModal />}

      {modalType === "rentalCarOptions" && <RentalCarOptionsModal /> }

      {modalType === "rentalCarSeekerOptions" && <RentalCarSeekerOptionsModal /> }

      {modalType === "updateRentalCarSeeker" && <UpdateRentalCarSeekerModal /> }

      {modalType === "deleteRentalCarSeeker" && <DeleteRentalCarSeekerModal /> }

      {modalType === "addKarayollariIstasyon" && <AddKarayollariIstasyonModal />}

      {modalType === "updateKarayollariIstasyon" && <UpdateKarayollariIstasyonModal />}

      {modalType === "createRoadRoute" && <CreateRoadRouteModal />}

      {modalType === "roadRouteOptions" && <RoadRouteOptionsModal />}

      {modalType === "createThirdRoadRoute" && <CreateThirdRoadRouteModal />}

      {modalType === "updateRoadRoute" && <UpdateRoadRouteModal />}

      {modalType === "adminRentalCarOptions" && <AdminRentalCarOptionsModal />}

      {modalType === "adminRentalCarDelete" && <AdminRentalCarDeleteModal />}

      {modalType === "adminRentalCarUpdate" && <AdminRentalCarUpdateModal />}

      {modalType === "adminRentalCarSeekerOptions" && <AdminRentalCarSeekerOptionsModal />}

      {modalType === "adminRentalCarSeekerDelete" && <AdminRentalCarSeekerDeleteModal />}

      {modalType === "adminRentalCarSeekerUpdate" && <AdminRentalCarSeekerUpdateModal />}

      {modalType === "adminDriverJobSeekerOptions" && <AdminDriverJobSeekerOptionsModal />}

      {modalType === "adminDriverJobSeekerDelete" && <AdminDriverJobSeekerDeleteModal />}

      {modalType === "adminDriverJobSeekerUpdate" && <AdminDriverJobSeekerUpdateModal />}

      {modalType === "adminDriverSeekerOptions" && <AdminDriverSeekerOptionsModal />}

      {modalType === "adminDriverSeekerDelete" && <AdminDriverSeekerDeleteModal />}

      {modalType === "adminDriverSeekerUpdate" && <AdminDriverSeekerUpdateModal />}

      {modalType === "topPagesWideMap" && <TopPagesWideMapModal />}

      {modalType === "topPagesTamamlananWideMap" && <TopPagesTamamlananWideMapModal />}
      
      {modalType === "publishingType2" && <PublishingType2Modal />}

      {modalType === "yukKaydiRapor" && <YukKaydiRaporModal />}

      {modalType === "ortalamaAracTedarikSure" && <OrtalamaAracTedarikModal />}

      {modalType === "arsivYukveGerecke" && <ArsivYukveGerekceModal />}

      {modalType === "yuklemeSureRapor" && <YuklemeSureleriModal />}

      {modalType === "bosaltmaSureRapor" && <BosaltmaSureleriModal />}

      {modalType === "enUzunSureliYukleme" && <EnUzunSureliYuklemeModal />}

      {modalType === "enUzunSureliBosaltma" && <EnUzunSureliBosaltmaModal />}
      
      {modalType === "yukVerenKayit" && <YukVerenKayitModal />}

      {modalType === "projeOlustur" && <ProjeOlusturModal />}

      {modalType === "projeDetay" && <ProjeDetayModal />}

      {modalType === "islemKayitItemReqRes" && <ReqResModal />}

      {modalType === "deletePermissionBolgedekiTeklifItem" && <DeletePermissionBolgedekiTeklifItemModal />}

      {/* //! kullanıp kullanılmadığı bakılacak */}
      {modalType === "updatePermissionCloseBolgedekiTeklif" && <UpdatePermissionCloseBolgedekiTeklifModal />}

      {/* //! kullanıp kullanılmadığı bakılacak */}
      {modalType === "loadOwnerProfile" && <LoadOwnerProfileModal />}

      {modalType === "freightInfo" && <FreightInfoModal />}

      {modalType === "clearPermisionLoadDataPiece" && <ClearPermisisonLoadDataPieceModal />}

      {modalType === "mobile-menu" && <MobileMenuModal/> }

      {modalType === "addYukBulBlockingMessage" && <AddYukBulBlockingMessageModal />}

      {modalType === "deleteYukbulBlockingMessageConfirm" && <DeleteYukbulBlockingMessageConfirmModal />}

      {modalType === "yukBulDeletePermission" && <YukBulDeletePermissionModal />}

      {modalType === "yukBulShareMessages" && <YukBulShareMessagesModal />}

      {modalType === "shareLocationTracking" && <ShareLocationTrackingModal/>}

      {modalType === "completeShipmentsPermission" && <CompleteShipmentsPermissionModal/>}

      {modalType === "updateShipmentContainerAndSealNumbers" && <UpdateShipmentContainerAndSealNumbersModal/>}

      {modalType === "deleteShipmentPermission" && <DeleteShipmentPermissionModal/>}

      {modalType === "updateShipmentVehicle" && <UpdateShipmentVehicleModal/>}

      {modalType === "adresKayitItemOptions" && <AdresKayitItemOptionsModal/>}

      {modalType === "yukKayitItemOptions" && <YukKayitItemOptionsModal/>}

      {modalType === "deleteScheduledNotificationPermission" && <DeleteScheduledNotificationPermissionModal/>}

      {modalType === "araclarYetkiBelgesiResult" && <AraclarYetkiBelgesiResultModal />}

      {modalType === "araclarMuayeneResult" && <AraclarMuayeneResultModal />}

      {modalType === "fastLoad" && <FastLoadModal />}

      {modalType === "portalMembersControlUpdate" && <PortalMembersControlUpdateModal />}

      {modalType === "portalMemberRejectedReason" && <PortalMemberRejectedReasonModal />}




      {/* //! ********************************************************************************************************************* */}

      {/* //! yeni devamlı sürücü eklemek için */}
      {modalType === "addRegularDriver" && <AddRegularDriverModal />}

      {/* //! yeni devamli sürücüye araç eklemek için / aynı zamanda mevcut devamli sürücüye de araç eklemek için */}
      {modalType === "addRegularDriversVehicle" && <AddRegularDriversVehicleModal />}

      {/* //! devamli sürüc eklerken telefon numarası sorgusunda sürücünün daha önceden eklenmiş olduğunda çıkan modal */}
      {modalType === "addDriverPhoneNumberExistingDesc" && <AddDriverPhoneNumberExistingDescModal />}

      {/* //! devali sürücü ekleme işlemi bittikten sonra araç da eklemek istermisin modalı */}
      {modalType === "addDriverAfterVehicleQuestion" && <AddDriverAfterVehicleQuestionModal />}

      {/* //! mevcut devamli sürücünün detaylarını gösteren modal */}
      {modalType === "regularDriverItemDetails" && <RegularDriverItemDetailsModal />}

      {/* //! bu devamlı sürücü ekleme listesinde yeni eklemede telefon sorgulama */}
      {modalType === "addRegularDriverPhoneNumberQuery" && <AddRegularDriverPhoneNumberQueryModal />}

      {/* //! bu mevcut devamlı sürücünün referans ve devamlı mısın güncellemesi */}
      {modalType === "updateRegularDriverRefAndRegular" && <UpdateRegularDriverRefAndRegularModal />}

      {modalType === "addJobListRegularVehicle" && <AddJobListRegularVehiclePhoneNumberQueryModal />}

      {modalType === "addDailyQueue" && <AddDailyQueueModal />}

      {nestedModalType === "regularVehicleList" && <RegularVehicleListModal />}

      
      {modalType === "shipmentOperation" && <ShipmentOperationModal />}

      {nestedModalType === "shipmentRouteOperation" && <ShipmentRouteOperationModal />}


      
      {/* //! kullanıp kullanılmadığı bakılacak */}
      {/* {modalType === "updateScheduledNotificationItem" && <UpdateScheduledNotificationItemModal/>} */}

      {nestedModalType === "adminAracSil" && <AdminAraclarAracSil />}

      {nestedModalType === "result" && <NestedResultModal />}

      {nestedModalType === "registeredAddressAbsoluteLocationMap" && <KayitliAdresMapModal />}

      {nestedModalType === "registeredAddressPolygonMap" && <KayitliAdresPolygonMapModal />}
      
      {nestedModalType === "firmaBilgileriSelectMap" && <FirmaBilgileriSelectMapModal />}

      {nestedModalType === "addLoadKayitResponse" && <AddLoadKayitResponseModal />}

      {nestedModalType === "addLoadYuklemeSecenekleriForKayit" && <AddLoadYuklemeSecenekleriForKayitModal />}

      {nestedModalType === "singleRouteMapUpdate" && <SingleRouteMapUpdateModal />}

      {nestedModalType === "aiSubTitleOrder" && <UpdateAiSubTitleOrderModal />}

      {nestedModalType === "allLoadBulk" && <AllLoadBulkModal />}

      {nestedModalType === "shipmentIrsaliyeWide" && <ShipmentIrsaliyeWideModal />}

      {nestedModalType === "firmalarimMapModal" && <FirmalarimMap /> }

      {nestedModalType === "firmalarimUpdateMapModal" && <FirmalarimUpdateMap /> }

      {nestedModalType === "loadOwnerImage" && <LoadOwnerImageModal />}

      {nestedModalType === "deleteLoadOwner" && <DeleteLoadOwnerModal />}

      {nestedModalType === "adminDeletePage" && <AdminDeletePageModal />}

      {nestedModalType === "publishingType2Update" && <PublishingType2UpdateModal />}

      {nestedModalType === "profilAracClose" && <ProfilAracCloseModal />}

      {nestedModalType === "deleteLoadPaketlemeItemPermission" && <DeleteLoadPaketlemeItemPermissionNestedModal /> }

      {nestedModalType === "deleteLoadRoutePermissionNested" && <DeleteLoadRoutePermissionNestedModal /> }
      
      {nestedModalType === "dateControlModal" && <DateControlModal />}

      {nestedModalType === "dateAfterControlModal" && <DateAfterControlModal />}

      {nestedModalType === "beforeDateControlModal" && <BeforeDateControlModal />}

      {nestedModalType === "MapChanges" && <MapChangesModal />}

      {nestedModalType === "MapDeleteRoute" && <MapDeleteRoute />}

      {nestedModalType === "surucuProfil" && <SurucuProfilModal />}

      {nestedModalType === "surucuProfilDegerlendir" && <SurucuProfilDegerlendirModal />}

      {nestedModalType === "surucuDegerlendirmeBilgi" && <SurucuDegerlendirmeBilgiModal />}

      {nestedModalType === "MapDeleteRoute" && <MapDeleteRoute />}

      {nestedModalType === "addGarajYogunlukEntry" &&  <AddGarajYogunlukEntryModal />}

      {nestedModalType === "addLoadRouteItemNotSavedDesc" && <AddLoadRouteItemNotSavedDescModal />}

      {nestedModalType === "devamliAraclarAracListeleme" && <DevamliAraclarAracListelemeModal />}



      {modalType === "adminDeleteBlogPermission" && <AdminDeleteBlogPermissionModal />}
      
      {modalType === "adminDeleteMultiBlogPermission" && <AdminDeleteMultiBlogPermissionModal />}


      {modalType === "sevkiyatRaporu" && <SevkiyatRaporuModal />}

      

      

      {/* //! kooperatifle alakalı olanlar kontrol edilecek koooeratif sıkıntı */}
      {modalType === "uyelerVeAraclarUyeEkle" && <UyelerVeAraclarUyeEkleModal />}
      {modalType === "kooperatifUyeDetay" && <KooperatifUyeDetayModal />}
      {modalType === "kooperatifTopluUyeEkle" && <KooperatifTopluUyeEkleModal />}
      {modalType === "KooperatifAraclarTekliAracEkle" && <KooperatifAraclarTekliAracEkle />}
      {modalType === "kooperatifAracGuncelle" && <KooperatifAracGuncelleModal />}
      {modalType === "kooperatifAraclarBelgeIslemler" && <KooperatifAraclarBelgeIslemlerModal />}
      {modalType === "kooperatifAraclarOptions" && <KooperatifAraclarOptionsModal />}
      {modalType === "kooperatifDorseBelgeIslemler" && <KooperatifDorseBelgeIslemlerModal />}
      {modalType === "kooperatifAracDetay" && <KooperatifAracDetayModal />}
      {modalType === "kooperatifTopluAracEkle" && <KooperatifTopluAracEkleModal />}
      {/* //! kooperatifle alakalı olanlar kontrol edilecek koooeratif sıkıntı */}

    </>
  );
};

export default ModalLayout;
